<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6736 16.9863C10.6342 16.9859 8.66299 16.2523 7.11956 14.9193L4.22656 8.98633H21.1586C21.031 11.1503 20.0816 13.1838 18.5043 14.6709C16.9271 16.158 14.8413 16.9863 12.6736 16.9863Z"
      fill="#D5D8DC"
    />
    <path
      d="M21.1571 8.986H13.2891V2C15.1964 2.10528 17.0121 2.85284 18.4406 4.12106C19.8691 5.38928 20.8265 7.10455 21.1571 8.986Z"
      fill="#21BF54"
    />
    <path
      d="M8.17188 21.9863C7.38075 21.9863 6.60739 21.7517 5.9496 21.3122C5.2918 20.8727 4.77911 20.248 4.47636 19.5171C4.17361 18.7862 4.09439 17.9819 4.24874 17.206C4.40308 16.43 4.78404 15.7173 5.34345 15.1579C5.90286 14.5985 6.61559 14.2175 7.39152 14.0632C8.16744 13.9088 8.97171 13.9881 9.70261 14.2908C10.4335 14.5936 11.0582 15.1063 11.4978 15.764C11.9373 16.4218 12.1719 17.1952 12.1719 17.9863C12.1719 19.0472 11.7504 20.0646 11.0003 20.8148C10.2502 21.5649 9.23274 21.9863 8.17188 21.9863ZM8.17188 15.9863C7.77631 15.9863 7.38963 16.1036 7.06074 16.3234C6.73184 16.5432 6.47549 16.8555 6.32412 17.221C6.17274 17.5864 6.13314 17.9885 6.21031 18.3765C6.28748 18.7645 6.47796 19.1208 6.75766 19.4005C7.03737 19.6802 7.39373 19.8707 7.7817 19.9479C8.16966 20.0251 8.57179 19.9855 8.93724 19.8341C9.3027 19.6827 9.61505 19.4264 9.83482 19.0975C10.0546 18.7686 10.1719 18.3819 10.1719 17.9863C10.1719 17.4559 9.96116 16.9472 9.58609 16.5721C9.21102 16.197 8.70231 15.9863 8.17188 15.9863Z"
      fill="#363C43"
    />
    <path
      d="M17.1719 21.9863C16.3808 21.9863 15.6074 21.7517 14.9496 21.3122C14.2918 20.8727 13.7791 20.248 13.4764 19.5171C13.1736 18.7862 13.0944 17.9819 13.2487 17.206C13.4031 16.43 13.784 15.7173 14.3434 15.1579C14.9029 14.5985 15.6156 14.2175 16.3915 14.0632C17.1674 13.9088 17.9717 13.9881 18.7026 14.2908C19.4335 14.5936 20.0582 15.1063 20.4978 15.764C20.9373 16.4218 21.1719 17.1952 21.1719 17.9863C21.1719 19.0472 20.7504 20.0646 20.0003 20.8148C19.2502 21.5649 18.2327 21.9863 17.1719 21.9863ZM17.1719 15.9863C16.7763 15.9863 16.3896 16.1036 16.0607 16.3234C15.7318 16.5432 15.4755 16.8555 15.3241 17.221C15.1727 17.5864 15.1331 17.9885 15.2103 18.3765C15.2875 18.7645 15.478 19.1208 15.7577 19.4005C16.0374 19.6802 16.3937 19.8707 16.7817 19.9479C17.1697 20.0251 17.5718 19.9855 17.9372 19.8341C18.3027 19.6827 18.6151 19.4264 18.8348 19.0975C19.0546 18.7686 19.1719 18.3819 19.1719 17.9863C19.1719 17.4559 18.9612 16.9472 18.5861 16.5721C18.211 16.197 17.7023 15.9863 17.1719 15.9863Z"
      fill="#363C43"
    />
    <path d="M2 6.98633H5.512L6.45 8.98633H2V6.98633Z" fill="#363C43" />
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
